module.exports = __webpack_public_path__ + "static/img/CC.694cc25d.svg";